import { createContext, useContext, useMemo } from 'react'

import type { TParametrosSimulacao } from '@/types/parametros-simulacao'

const ParametrosSimulacaoContext = createContext<TParametrosSimulacao | null>(null)

export const useParametrosSimulacaoContext = () => {
  const context = useContext(ParametrosSimulacaoContext)
  if (!context) {
    throw new Error('useParametrosSimulacaoContext must be used within a ParametrosSimulacaoProvider')
  }

  const parametrosEstaticos = useMemo(
    () => ({
      parametrosTaxaDeCambioChile: context.parametrosTaxaDeCambioChile,
      parametrosTaxaAnualDividendos: context.parametrosTaxaAnualDividendos,
    }),
    [context.parametrosTaxaDeCambioChile, context.parametrosTaxaAnualDividendos],
  )

  return { ...context, parametrosEstaticos }
}

export const ParametrosSimulacaoProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value: TParametrosSimulacao
}) => <ParametrosSimulacaoContext.Provider value={value}>{children}</ParametrosSimulacaoContext.Provider>
